
















































































import { Component, Prop, Vue } from "vue-property-decorator";

declare var TweenMax: any;
declare var Expo: any;

@Component
export default class Panels extends Vue {
	formName: string = "";
	formEmail: string = "";
	formMessage: string = "";
	activePanel?: HTMLElement;
	keepMenuPos: boolean = false;
	errors: any = [];
	isMobile: boolean = window.matchMedia("screen and (max-width: 679px)")
		.matches;

	mounted() {}

	sendForm(event: MouseEvent) {
		this.errors = [];
		let _errors: any = [];

		if (!this.formName) {
			_errors.push("Name required.");
		}
		if (!this.formEmail) {
			_errors.push("Email required.");
		} else if (!this.validEmail(this.formEmail)) {
			_errors.push("Valid email required.");
		}

		if (_errors.length > 0) {
			setTimeout(() => (this.errors = _errors), 400);
		} else {
			this.closeActive(true);
			this.$emit("onMessage", {
				to: "lars@pixelunit.dk",
				message: {
					subject: "Hello from Pixelunit!",
					text: `Name: ${this.formName}, Email: ${this.formEmail}\n\n${this.formMessage}`,
					html: `<p>Name: ${this.formName}</p><p>Email: ${this.formEmail}</p><p>${this.formMessage}</p>`
				}
			});
			this.formName = "";
			this.formEmail = "";
			this.formMessage = "";
		}

		event.preventDefault();
	}

	validEmail(email: string) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
	open($panel: HTMLElement) {
		let _x: string = this.isMobile ? "-100%" : "440";
		$panel.classList.toggle("is-open");
		TweenMax.to(".menu", 0.6, { ease: Expo.easeInOut, right: _x, delay: 0.4 });
		TweenMax.to($panel, 0.6, { ease: Expo.easeInOut, right: 0, delay: 0.4 });
		this.activePanel = $panel;
	}

	closeActive(closeMenu: boolean = false) {
		let _x: string = this.isMobile ? "-100%" : "-438";
		TweenMax.to(this.activePanel, 0.6, { ease: Expo.easeInOut, right: _x });
		if (closeMenu) {
			TweenMax.to(".menu", 0.6, { ease: Expo.easeInOut, right: 0, delay: 0.4 });
			this.activePanel = undefined;
			this.$emit("close");
		}
	}

	public togglePanel(panel: string) {
		let $panel = document.getElementById(panel);
		if (this.activePanel) {
			this.closeActive();
		}
		if ($panel !== null) {
			this.open($panel);
		}
	}
}
